module.exports = __webpack_public_path__ + "images/tour-3d-1-c4974fbb63591e3dacfcffb3cb063924.jpg";